import axios from 'axios'
import { merge } from 'lodash'
import Form from './Form'

axios.defaults.timeout = 180000;
axios.defaults.baseURL = '/api/v1/';
axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Accept': 'application/json',
}

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

if (window.auth && window.auth.token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${window.auth.token}`
}

export default {
    async get(url, config = {}) {
        return this.send('get', url, {}, config)
    },

    async post(url, data = {}, config = {}) {
        return this.send('post', url, data, config)
    },

    async put(url, data = {}, config = {}) {
        return this.send('put', url, data, config)
    },

    async patch(url, data = {}, config = {}) {
        return this.send('patch', url, data, config)
    },

    async delete(url, data = {}, config = {}) {
        return this.send('delete', url, data, config)
    },

    async send(method, url, data = {}, config = {}) {
        if (data instanceof Form) {
            data = data.export()
        }

        if (data instanceof FormData) {
            data.append('_method', method)
            method = 'post'
            config = merge(config, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
        }

        const response = await axios({method, url, data, ...config})
        return response.data
    },
}
